import { useRecoilState } from 'recoil';
import { Button } from 'components/core';
import { builderAnswersState } from 'states';
import { advancedProblems, blankQuery } from 'helpers/kpiBuilder/advanced';
import { AdvancedQuery } from 'helpers/kpiBuilder/types';
import { AdvancedQueryCard } from './AdvancedQueryCard';
import { BuilderSection } from './BuilderSection';
import { OUTLINE_SMALL } from './buttonProps';

// A KPI built part by part: every part a hand-written query has can be edited here.
export const AdvancedStep = () => {
  const [a, setA] = useRecoilState(builderAnswersState);
  const queries = a.advanced.queries;
  const save = (next: AdvancedQuery[]) => setA({ ...a, advanced: { queries: next } });
  const problems = advancedProblems(a.advanced);
  const add = () => {
    save([...queries, blankQuery()]);
  };

  return (
    <>
      <BuilderSection
        title="Build the query yourself"
        hint="For anything the other questions do not cover. Add each query, then the aggregations it asks for: any type, one inside another, with its settings as JSON. The handler and extra dashboard filters are at the bottom, and extra settings are on the Additional Config tab."
      >
        {queries.map((q, i) => (
          <AdvancedQueryCard
            key={i}
            query={q}
            index={i}
            onChange={(next) => save(queries.map((x, j) => (j === i ? next : x)))}
            onRemove={queries.length > 1 ? () => save(queries.filter((_, j) => j !== i)) : undefined}
          />
        ))}
        <Button {...OUTLINE_SMALL} onClick={add}>
          Add another query
        </Button>
      </BuilderSection>
      {problems.length > 0 && (
        <div className="alert alert-warning" role="status">
          <strong>Still to fix:</strong>
          <ul className="mb-0">
            {problems.map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};
